import React from 'react';
import './index.css';

const TopBar = () => {
  return (
    <div className="topbar">
     <a href="https://solar-ratgeber.ch"> <img alt="logo2" className="logoleft" src="/assets/logo2.png" /></a>
      {/* Language picker removed */}
    </div>
  );
};

export default TopBar;
